// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2T-zs","rootMobile":"styles_rootMobile__12NbT"};